import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import { useDateLocale } from '../../../../../hooks'
import { NotificationInline } from '../../../../Notification'
import Text from '../../../../Text'
import { getIsCalendarDayLoadFull } from '../../../Calendar.utils'
import {
  QA_NAME_CALENDAR_TASK_MOVE_DAY_LOAD,
  QA_NAME_CALENDAR_TASK_MOVE_DAY_LOAD_FAILED,
} from '../../CalendarTaskMoveModal.constants'

import { getCalendarTaskMoveDayLoadWarning } from './DayLoadNotice.utils'

function DayLoadNotice({ dayLoad, isFailed }) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  return getIsCalendarDayLoadFull(dayLoad) ? (
    <NotificationInline
      qaName={QA_NAME_CALENDAR_TASK_MOVE_DAY_LOAD}
      text={getCalendarTaskMoveDayLoadWarning({ dayLoad, locale, t })}
      type={NOTIFICATION_TYPE.warning}
    />
  ) : isFailed ? (
    <Text isSecondary qaName={QA_NAME_CALENDAR_TASK_MOVE_DAY_LOAD_FAILED}>
      {t('Calendar.LoadCheckFailedKey')}
    </Text>
  ) : null
}

export default DayLoadNotice
